import {
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    usePermissions
} from "shared";

import MainContainer from "../MainContainer";
import Table from "../Table";
import TaskGroupsTable from "./TaskGroupsTable";

const Tasks = () => {
    const { isReadTaskGroupNotAllowed } = usePermissions();

    return (
        <MainContainer>
            <Table
                name={TABLE_NAMES.TaskGroups}
                nameForFilters={TABLE_NAMES_WITH_FILTERS.TaskGroups}
                hasNoPermissionToRead={isReadTaskGroupNotAllowed}
                idType={ID_TYPE.Id}
                customTable={<TaskGroupsTable />}
                sortFromNewest
                hasActionBar
                hideSearch
            />
        </MainContainer>
    );
};

export default Tasks;
